import React from 'react';
import { IIconProps } from './utils';

export const Frame = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 15 14" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M13.5278 0H1.39943C0.626826 0 0 0.626826 0 1.39943V11.6619C0 12.4345 0.626826 13.0613 1.39943 13.0613H13.5278C14.3004 13.0613 14.9272 12.4345 14.9272 11.6619V1.39943C14.9272 0.626826 14.3004 0 13.5278 0ZM13.5278 11.4869C13.5278 11.5832 13.4491 11.6619 13.3528 11.6619H1.57435C1.47814 11.6619 1.39943 11.5832 1.39943 11.4869V4.66475H13.5278V11.4869Z"
      fill={fill}
    />
  </svg>
);
